import React from 'react';

import { useAppleWalletPass } from '../../hooks/useAppleWalletPass';
import { WalletPassButton } from './WalletPassButton';
import { useSettings } from '@vmos2/providers';

type Props = {
  pageName: string,
  mode?: string,
  width?: string,
};

export const AddToAppleWallet = ({ mode, width, pageName }: Props) => {
  const walletProps = useAppleWalletPass();
  const { loyaltyWalletPass } = useSettings();

  if (!loyaltyWalletPass?.ios?.[pageName]) {
    return null;
  }

  return <WalletPassButton {...walletProps} mode={mode} width={width} variant="apple" />;
};
